





















import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class Unoptomized extends Vue {
  emailAddress: string | null = null;

  mounted() {
    this.emailAddress = this.$route.params.emailAddress;
  }
  emailMeTheWebappLogin(): void {
    this.$router.push('/');
  }
}
